<script>
import IniciarConversaModal from './IniciarConversaModal.vue';

export default {
  name: 'IniciarConversaFab',
  components: { IniciarConversaModal },
  data() {
    return {
      aberto: false,
      // Empurra o FAB pra cima apenas quando o footer está fixo (overlap real).
      // Detectado dinamicamente: se computed position do .footer === 'fixed', sobe.
      footerFixo: false,
    };
  },
  mounted() {
    this._detectarFooter();
    // Re-detecta em resize (layout pode trocar entre fixed/relative)
    window.addEventListener('resize', this._detectarFooter);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this._detectarFooter);
  },
  methods: {
    _detectarFooter() {
      try {
        const footer = document.querySelector('.footer');
        if (!footer) { this.footerFixo = false; return; }
        const pos = window.getComputedStyle(footer).position;
        this.footerFixo = (pos === 'fixed' || pos === 'sticky');
      } catch (_e) {
        this.footerFixo = false;
      }
    },
  },
};
</script>

<template>
  <div>
    <button
      type="button"
      class="iniciar-conversa-fab"
      :class="{ 'sobre-footer-fixo': footerFixo }"
      :title="'Iniciar nova conversa'"
      @click="aberto = true"
    >
      <i class="ri-add-line fab-icon"></i>
      <span class="fab-label d-none d-md-inline">Nova conversa</span>
    </button>

    <IniciarConversaModal
      v-if="aberto"
      @close="aberto = false"
    />
  </div>
</template>

<style scoped>
.iniciar-conversa-fab {
  position: fixed;
  right: 1.5rem;
  bottom: calc(1.5rem + 40px); /* sobe 40px do canto */
  z-index: 1040;
  transition: bottom 0.15s ease, transform 0.15s, box-shadow 0.15s, background 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.1rem;
  background: var(--vz-primary);
  color: #fff;
  border: 0;
  border-radius: 999px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  cursor: pointer;
  font-weight: 600;
  font-size: 0.95rem;
}
.iniciar-conversa-fab.sobre-footer-fixo {
  bottom: calc(1.5rem + 40px + 50px); /* sobe 40px + afasta do footer fixo */
}
.iniciar-conversa-fab:hover {
  background: var(--brand-primary-hover, #7a0e14);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.25);
  transform: translateY(-1px);
}
.iniciar-conversa-fab:active { transform: translateY(0); }

.fab-icon {
  font-size: 1.25rem;
  line-height: 1;
}

/* Mobile: vira só ícone redondo, acima da bottom nav (58px) — mesma
   posição do FAB de Canais/Notícias. */
@media (max-width: 767px) {
  .iniciar-conversa-fab {
    width: 56px;
    height: 56px;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
    right: 1.25rem;
    bottom: calc(58px + 1rem + env(safe-area-inset-bottom, 0px));
    z-index: 1045;
  }
  /* No mobile o rodapé é a bottom nav (não o .footer), então ignora o
     deslocamento de footer fixo pra não subir demais. */
  .iniciar-conversa-fab.sobre-footer-fixo {
    bottom: calc(58px + 1rem + env(safe-area-inset-bottom, 0px));
  }
  .fab-icon { font-size: 1.6rem; }
}
</style>
